import React from 'react';
import { TextField } from '@mui/material';

const NumericTextField = ({ label, value, onChange, required, helperText, error }) => {

    const handleChange = (e) => {
        const val = e.target.value;

        if (!/^\d*$/.test(val)) return;
        if (val.length > 9) return;

        onChange(val);
    };

    return (
        <TextField
            fullWidth
            label={label}
            variant="filled" // variant="outlined"
            value={value || ""}
            required={required}
            helperText={helperText}
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 9 }}
            onChange={handleChange}
            // onChange={(e) => onChange(e.target.value)} // Directly passing the new value to onChange
        />
    );
};

export default NumericTextField;
